// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".out-stock-list[data-v-7c58e8a4] {\n  height: 100%;\n}\n.out-stock-list .muted[data-v-7c58e8a4] {\n  color: var(--yq-font-color-desc);\n  font-size: 0.32rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
